export default "__VITE_ASSET__5dc2d15c__"